class PPGiftCardProduct {
  constructor() {
    this.labels = new Map([
      ['£10.00 GBP', '£10'],
      ['£25.00 GBP', '£25'],
      ['£50.00 GBP', '£50'],
      ['£100.00 GBP', '£100'],
    ]);
    this.product = document.querySelector('.product');
    if (!this.product) return;

    this.formatLabels();
    this.prepareQuantity();
    this.observer = new MutationObserver(() => this.formatLabels());
    this.observer.observe(this.product, { childList: true, subtree: true });
  }

  formatLabels() {
    this.product.querySelectorAll('[id^="MULTIVARIANTS_APP"]').forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const label = node.textContent.trim();
        if (this.labels.has(label)) node.textContent = node.textContent.replace(label, this.labels.get(label));
      }
    });
  }

  prepareQuantity() {
    const input = this.product.querySelector('.pp-gift-card-quantity input[name="quantity"]');
    if (!input) return;
    input.min = '1';
    const normalize = () => {
      const quantity = Number.parseInt(input.value, 10);
      input.value = Number.isFinite(quantity) ? Math.max(1, quantity) : 1;
    };
    input.addEventListener('change', normalize);
    input.addEventListener('blur', normalize);
    input.form?.addEventListener('submit', normalize);
  }
}
new PPGiftCardProduct();